import React from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { getUserData } from "../../actions/userdata";
import { toggleLoader } from "../../actions/loader";
const LeftbarAdmin = (props) => {
  const closeSidebar = () => {
    document.body.classList.remove('sidebar-open');
  };

  return (
    <>
      <div className="sidebar-overlay" onClick={closeSidebar} />
      <aside className="sidenav navbar navbar-vertical navbar-expand-xs fixed-left">
        <div className="sidenav-header">
          {/* <div className="sidenav-toggler">
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
            </div>
          </div> */}
          <a className="navbar-brand m-0" href="#">
            <img
              src="/img/logo.png"
              className="navbar-brand-img h-100 w-13"
              alt="..."
              style={{ marginRight: "8px" }}
            />
            <span
              className="ms-1 font-weight-bold"
              style={{ fontSize: "16px" }}
            >
              {" "}
              Mothrly{" "}
            </span>
          </a>
        </div>
        <div className="collapse navbar-collapse  w-auto">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/dashboard"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-th-large" />
                </div>
                <span className="nav-link-text ms-1">Dashboard</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/users"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-users" />
                </div>
                <span className="nav-link-text ms-1">Users</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/gynac-list"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-user-md" />
                </div>
                <span className="nav-link-text ms-1">Gynac List</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/yoga-trainers"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-spa" />
                </div>
                <span className="nav-link-text ms-1">Yoga trainers</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/pediatric"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-baby" />
                </div>
                <span className="nav-link-text ms-1">Pediatricians</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/services"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-concierge-bell" />
                </div>
                <span className="nav-link-text ms-1">Services</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/providers"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-user-friends" />
                </div>
                <span className="nav-link-text ms-1">Service Providers</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/bookings"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-calendar-check" />
                </div>
                <span className="nav-link-text ms-1">Bookings</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/expenses"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-wallet" />
                </div>
                <span className="nav-link-text ms-1">Expenses</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/extra-payments"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-money-bill-wave" />
                </div>
                <span className="nav-link-text ms-1">Payment Requests</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/reservations"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-bookmark" />
                </div>
                <span className="nav-link-text ms-1">Reservations</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/medical-condition"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-file-medical" />
                </div>
                <span className="nav-link-text ms-1">Medical Conditions</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/coupons"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-tags" />
                </div>
                <span className="nav-link-text ms-1">Coupons</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/assessment"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-clipboard-list" />
                </div>
                <span className="nav-link-text ms-1">Assessment</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/faqs"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-question-circle" />
                </div>
                <span className="nav-link-text ms-1">FAQ</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                onClick={closeSidebar}
                to={"/update-password"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-lock" />
                </div>
                <span className="nav-link-text ms-1">Update Password</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

const mapDispatchToProps = {
  toggleLoader,
  getUserData,
};
const mapStateToProps = (state) => {
  return {
    userdata: state.userdata?.userData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LeftbarAdmin);
